"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpWizardViewAttemptModal: {
        feedback: 'Feedback',
        notepad: 'Notes',
        header: {
            title: 'Question {{index}}',
            awarded: '{{count}} point awarded',
            awarded_plural: '{{count}} points awarded',
        },
    },
};
